import React, { useEffect, useRef } from 'react';
import { Col, Row } from 'components/Core/Grid';
import WebsiteImage from 'components/WebsiteImage';
import VideoButton from 'components/Core/Video/VideoButton';
import useWindowDimensions from 'hooks/useWindowDimensions';
import {
  WorkshopColumn,
  WorkshopRow,
  WorkshopContentCol,
  VideoCol,
  RegisterButton,
} from './styles';

const Workshop = ({ title, featuredImage, excerpt, registrationLink, recordedVideo, gridMode }) => {
  const excerptRef = useRef();
  const windowWidth = useWindowDimensions().innerWidth;

  useEffect(() => {
    if (gridMode && excerptRef?.current) {
      const excerptContent = excerptRef.current;
      if (excerptContent && excerpt?.excerpt) {
        const pTag = excerptContent.lastElementChild;
        pTag.innerHTML = excerpt?.excerpt;
        const wordArray = excerpt?.excerpt?.split(' ');
        while (excerptContent.offsetHeight < pTag.offsetHeight) {
          wordArray.pop();
          pTag.innerHTML = `${wordArray.join(' ')}...`;
        }
      }
    }
  }, [gridMode, windowWidth]);

  return (
    <WorkshopColumn md={gridMode ? 8 : 24} className={gridMode ? 'grid' : ''}>
      <WorkshopRow className={gridMode ? 'grid' : ''}>
        <Col className="image-row" md={24} xs={0}>
          {featuredImage && <WebsiteImage image={featuredImage.image} alt={featuredImage?.alt} />}
        </Col>
        <Row className="workshop-content">
          <WorkshopContentCol md={gridMode ? 24 : 20} xs={24}>
            <div className="content-container">
              <h5>{title}</h5>
              <div ref={excerptRef}>
                <p>{excerpt?.excerpt}</p>
              </div>
            </div>
          </WorkshopContentCol>
          <Col md={gridMode ? 24 : 4} xs={24}>
            <Row>
              <Col
                className="workshop-content--register-button-container"
                md={gridMode && recordedVideo ? 12 : 24}
                xs={12}
              >
                <RegisterButton type="secondary" size="small" to={registrationLink}>
                  Register Now
                </RegisterButton>
              </Col>
              {recordedVideo && (
                <VideoCol md={gridMode ? 12 : 24} xs={12}>
                  <VideoButton
                    mainSrc={recordedVideo?.file?.url || recordedVideo?.url}
                    title="Watch Recording"
                  />
                </VideoCol>
              )}
            </Row>
          </Col>
        </Row>
      </WorkshopRow>
    </WorkshopColumn>
  );
};

export default Workshop;
